export const fonts = {
  display: "'Outfit', 'Plus Jakarta Sans', sans-serif",
  body: "'Plus Jakarta Sans', sans-serif",
  mono: "'IBM Plex Mono', monospace",
};

// Theme palette matching the WIBIL Shield Artwork (Sapphire Blue, Radiant Sky Cyan, Gold)
export const themeModes = {
  dark: {
    key: "dark",
    bg: "linear-gradient(180deg, #0B1B3D 0%, #081226 100%)",
    canvas: "#0B1B3D",
    surface: "rgba(15, 35, 71, 0.85)",
    surfaceRaised: "rgba(255, 255, 255, 0.08)",
    line: "rgba(255, 255, 255, 0.15)",
    border: "rgba(255, 255, 255, 0.2)",
    text: "#FFFFFF",
    textMute: "rgba(255, 255, 255, 0.75)",
    accent: "#0284C7",
    accentText: "#FFFFFF",
    accentDim: "rgba(2, 132, 199, 0.2)",
    badgeBg: "rgba(2, 132, 199, 0.2)",
    badgeText: "#38BDF8",
    navBg: "rgba(11, 27, 61, 0.9)",
  },
  light: {
    key: "light",
    bg: "#F0F7FF",
    canvas: "#F0F7FF",
    surface: "#FFFFFF",
    surfaceRaised: "#E0F2FE",
    line: "#BAE6FD",
    border: "#7DD3FC",
    text: "#0B1B3D",
    textMute: "#0369A1",
    accent: "#0284C7",
    accentText: "#FFFFFF",
    accentDim: "#E0F2FE",
    badgeBg: "#E0F2FE",
    badgeText: "#0369A1",
    navBg: "#FFFFFF",
  }
};

export function getTheme(pageKey = "default", mode = "dark") {
  const selectedMode = (mode === "light") ? "light" : "dark";
  return themeModes[selectedMode];
}

export function scoreColor(score) {
  if (score >= 750) return "#10B981"; // Vibrant Emerald
  if (score >= 600) return "#F59E0B"; // Trust Amber
  return "#EF4444";
}

export const loginTheme = themeModes.dark;
export const employeeTheme = themeModes.dark;
export const employerTheme = themeModes.dark;
